import { Button, CircularProgress } from '@mui/material';
import { BalanceDepositType } from 'constants/balance.constants';

export interface ButtonProps {
	text: string;
	disabled?: boolean;
	loading?: boolean;
	onClick: () => void;
	buttonOption: BalanceDepositType;
	fullWidth?: boolean;
}

export default function BalanceDashbaordCardButton({
	text,
	disabled = false,
	loading = false,
	onClick,
	buttonOption,
	fullWidth = false,
}: ButtonProps) {
	const getButtonStyles = () => {
		const baseStyles = {
			padding: {
				xs: '10px 20px',
				sm: '0.875rem 1.5rem', // 14px 24px
				md: '1rem 1.75rem', // 16px 28px
			},
			gap: { xs: '10px' },
			borderRadius: '5px',
			fontSize: {
				xs: '18px',
				sm: '1rem', // 16px
				md: '1.125rem', // 18px
			},
			fontWeight: 600,
			lineHeight: {
				xs: 1.4,
				sm: 1.44,
				md: 1.44,
			},
			minWidth: {
				xs: fullWidth ? '100%' : '144px',
				sm: fullWidth ? '100%' : '10rem',
				md: fullWidth ? '100%' : '11.875rem',
			},
			minHeight: {
				xs: '50px',
				sm: '3rem', // 48px
				md: '3.125rem', // 50px
			},
			boxShadow: 'none',
			width: fullWidth ? '100%' : { xs: '30px', sm: '160px', md: '190px' },
			height: '45px',
			textTransform: 'none' as const,
			transition: 'all 0.2s ease-in-out',
			'--bg-color': '#004D35',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
		};

		switch (buttonOption) {
			case BalanceDepositType.Digital:
				return {
					...baseStyles,
					backgroundColor: 'var(--bg-color)',
					color: '#FFFFFF',
					'&:hover': {
						backgroundColor: '#003A28',
						boxShadow: 'none',
						transform: 'translateY(-0.125rem)',
					},
					'&:disabled': {
						backgroundColor: '#8E8E93',
						color: 'white',
						transform: 'none',
					},
					'&:active': {
						transform: 'translateY(0)',
					},
				};
			case BalanceDepositType.Manual:
				return {
					...baseStyles,
					backgroundColor: 'inherit',
					color: 'var(--bg-color)',
					border: '1px solid var(--bg-color)',
					'&:hover': {
						backgroundColor: '#E8F5F2',
						boxShadow: 'none',
						transform: 'translateY(-0.125rem)',
					},
					'&:disabled': {
						backgroundColor: '#8E8E93',
						color: 'white',
						transform: 'none',
					},
					'&:active': {
						transform: 'translateY(0)',
					},
				};
			default:
				return baseStyles;
		}
	};

	return (
		<Button variant="contained" disabled={disabled || loading} onClick={onClick} sx={getButtonStyles()}>
			{loading ? <CircularProgress size={22} color="inherit" /> : text}
		</Button>
	);
}
